import React from 'react';
import img5 from '../../assets/logos/img4.png';

import './Modal.css';

const Modal = ({ open, onClose }) => {
  if (!open) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-body">
          <div className="profile-modal1-left">
            <img src={img5} alt="img5" className="profile-modal1-img" />
          </div>
          <div className="profile-right">
            <div class="cv-section">
              <h2>VGM</h2>

              <h3>Nos especializamos en:</h3>

              <h4>Asesoría Fiscal Internacional</h4>
              <ul>
                <li>Diseño de esquemas fiscales e impositivos internacionales para empresas e individuos.</li>
                <li>Cumplimiento de normativas internacionales y revisión constante de actualizaciones.</li>
              </ul>

              <h4>Compliance Internacional</h4>
              <ul>
                <li>Elaboración y actualización de manuales de cumplimiento adaptados a regulaciones globales.</li>
                <li>Revisión de normativas y soporte a estructuras complejas como MSB (Money Service Businesses) y VASP (Virtual Asset Service Providers).</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
